import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type CmsIcons } from '@redteclab/api/clients/content-management-system'

import { HeaderInlineIcon } from '../HeaderInlineIcon'

import styles from './HeaderCategoriesMenuIconButton.module.css'

type HeaderCategoriesMenuIconButtonProps = ComponentProps<'button'> & {
  icon?: CmsIcons
  menuIsShown: boolean
}

export const HeaderCategoriesMenuIconButton: FC<
  HeaderCategoriesMenuIconButtonProps
> = ({ children, className, icon, menuIsShown, ...rest }) => (
  <button
    aria-controls="categories-menu"
    aria-haspopup="true"
    className={clsx(
      styles['header-categories-menu-icon-button'],
      menuIsShown && styles['header-categories-menu-icon-button_expanded'],
      className,
    )}
    data-qa-id="form-categories"
    role="menuitem"
    type="button"
    {...rest}
  >
    <HeaderInlineIcon className="my-2.5 mr-2.5 text-3xl" icon={icon} />
    {children ?? (
      <span className="sr-only">
        <FormattedMessage id="navigation.button.label.menu" />
      </span>
    )}
  </button>
)
